import {
  TextWrap,
  TextWrapUnreadV2,
  trimOverlengthStringWork,
} from '../Common/CellText'
import React from 'react'

const UnreadTextWork = props => {
  return props.isUnread ? (
    <TextWrapUnreadV2>
      {trimOverlengthStringWork(props.text, props.width)}
    </TextWrapUnreadV2>
  ) : (
    <TextWrap>{trimOverlengthStringWork(props.text, props.width)}</TextWrap>
  )
}

export default UnreadTextWork
